export default __webpack_public_path__ + "static/screeny-130-gpz-i-4-7c97048f5d53da629721eb6fe9ee0d27.jpg";